export class PollingService {
  startPolling<T>(
    pollFunction: () => Promise<T>,
    acceptResult: (result: T) => void,
    shouldContinuePolling: (result: T) => boolean,
    intervalMs: number
  ): NodeJS.Timeout {
    const interval = setInterval(async () => {
      try {
        const result = await pollFunction();
        acceptResult(result);
        if (!shouldContinuePolling(result)) {
          clearInterval(interval);
        }
      } catch (error) {
        console.error('Polling error:', error);
      }
    }, intervalMs);

    return interval;
  }

  stopPolling(interval: NodeJS.Timeout | null): void {
    if (interval) {
      clearInterval(interval);
    }
  }
}
